import { createRequest } from '@savgroup-front-common/core/services/request';

export const LOAD_FILE_ACTIONS = createRequest('LOAD_FILE_ACTIONS');
export const SET_FILE_ACTION = createRequest('SET_FILE_ACTION');
